export default "/_next/static/sounds/trim-page-turn-1-343e63ea97debf21db33cb8b220c8f8d.mp3";